function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flag",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1988.351 1050",
    style: {
      enableBackground: "new 0 0 1988.351 1050"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 3.933,
    style: {
      fill: "#FFFFFF"
    },
    width: 1988.351,
    height: 1042.192
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.055,
    y: 0.014,
    style: {
      fill: "#B22234"
    },
    width: 1988.297,
    height: 82.442
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.055,
    y: 161.273,
    style: {
      fill: "#B22234"
    },
    width: 1988.297,
    height: 82.44
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.055,
    y: 322.529,
    style: {
      fill: "#B22234"
    },
    width: 1988.297,
    height: 82.441
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.055,
    y: 483.786,
    style: {
      fill: "#B22234"
    },
    width: 1988.297,
    height: 82.441
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.055,
    y: 645.043,
    style: {
      fill: "#B22234"
    },
    width: 1988.297,
    height: 82.443
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.055,
    y: 806.302,
    style: {
      fill: "#B22234"
    },
    width: 1988.297,
    height: 82.441
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.055,
    y: 967.558,
    style: {
      fill: "#B22234"
    },
    width: 1988.297,
    height: 82.441
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3C3B6E"
    },
    width: 794.114,
    height: 566.247
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "67.542,21.684 74.973,44.798 99.022,44.798 79.565,59.083 86.998,82.198 67.542,67.913  48.086,82.198 55.517,59.083 36.06,44.798 60.109,44.798  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "132.992,79.785 140.423,102.9 164.472,102.9 145.018,117.185 152.448,140.299  132.992,126.015 113.536,140.299 120.967,117.185 101.513,102.9 125.562,102.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "132.992,193.306 140.423,216.421 164.472,216.421 145.018,230.706 152.448,253.82  132.992,239.536 113.536,253.82 120.967,230.706 101.513,216.421 125.562,216.421  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "132.992,306.827 140.423,329.942 164.472,329.942 145.018,344.227 152.448,367.341  132.992,353.057 113.536,367.341 120.967,344.227 101.513,329.942 125.562,329.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "132.992,420.348 140.423,443.463 164.472,443.463 145.018,457.748 152.448,480.863  132.992,466.578 113.536,480.863 120.967,457.748 101.513,443.463 125.562,443.463  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "265.664,79.785 273.094,102.9 297.143,102.9 277.687,117.185 285.12,140.299  265.664,126.015 246.207,140.299 253.638,117.185 234.182,102.9 258.231,102.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "265.664,193.306 273.094,216.421 297.143,216.421 277.687,230.706 285.12,253.82  265.664,239.536 246.207,253.82 253.638,230.706 234.182,216.421 258.231,216.421  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "265.664,306.827 273.094,329.942 297.143,329.942 277.687,344.227 285.12,367.341  265.664,353.057 246.207,367.341 253.638,344.227 234.182,329.942 258.231,329.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "265.664,420.348 273.094,443.463 297.143,443.463 277.687,457.748 285.12,480.863  265.664,466.578 246.207,480.863 253.638,457.748 234.182,443.463 258.231,443.463  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "398.335,79.785 405.766,102.9 429.814,102.9 410.358,117.185 417.791,140.299  398.335,126.015 378.879,140.299 386.309,117.185 366.853,102.9 390.902,102.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "398.335,193.306 405.766,216.421 429.814,216.421 410.358,230.706 417.791,253.82  398.335,239.536 378.879,253.82 386.309,230.706 366.853,216.421 390.902,216.421  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "398.335,306.827 405.766,329.942 429.814,329.942 410.358,344.227 417.791,367.341  398.335,353.057 378.879,367.341 386.309,344.227 366.853,329.942 390.902,329.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "398.335,420.348 405.766,443.463 429.814,443.463 410.358,457.748 417.791,480.863  398.335,466.578 378.879,480.863 386.309,457.748 366.853,443.463 390.902,443.463  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "531.004,79.785 538.437,102.9 562.486,102.9 543.03,117.185 550.46,140.299  531.004,126.015 511.55,140.299 518.981,117.185 499.525,102.9 523.573,102.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "531.004,193.306 538.437,216.421 562.486,216.421 543.03,230.706 550.46,253.82  531.004,239.536 511.55,253.82 518.981,230.706 499.525,216.421 523.573,216.421  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "531.004,306.827 538.437,329.942 562.486,329.942 543.03,344.227 550.46,367.341  531.004,353.057 511.55,367.341 518.981,344.227 499.525,329.942 523.573,329.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "531.004,420.348 538.437,443.463 562.486,443.463 543.03,457.748 550.46,480.863  531.004,466.578 511.55,480.863 518.981,457.748 499.525,443.463 523.573,443.463  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "663.675,79.785 671.108,102.9 695.155,102.9 675.701,117.185 683.131,140.299  663.675,126.015 644.221,140.299 651.652,117.185 632.196,102.9 656.245,102.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "663.675,193.306 671.108,216.421 695.155,216.421 675.701,230.706 683.131,253.82  663.675,239.536 644.221,253.82 651.652,230.706 632.196,216.421 656.245,216.421  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "663.675,306.827 671.108,329.942 695.155,329.942 675.701,344.227 683.131,367.341  663.675,353.057 644.221,367.341 651.652,344.227 632.196,329.942 656.245,329.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "663.675,420.348 671.108,443.463 695.155,443.463 675.701,457.748 683.131,480.863  663.675,466.578 644.221,480.863 651.652,457.748 632.196,443.463 656.245,443.463  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "67.542,135.205 74.973,158.319 99.022,158.319 79.565,172.604 86.998,195.719  67.542,181.434 48.086,195.719 55.517,172.604 36.06,158.319 60.109,158.319  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "67.542,248.726 74.973,271.84 99.022,271.84 79.565,286.125 86.998,309.24 67.542,294.955  48.086,309.24 55.517,286.125 36.06,271.84 60.109,271.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "67.542,362.247 74.973,385.361 99.022,385.361 79.565,399.646 86.998,422.761  67.542,408.476 48.086,422.761 55.517,399.646 36.06,385.361 60.109,385.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "67.542,475.768 74.973,498.883 99.022,498.883 79.565,513.167 86.998,536.282  67.542,521.997 48.086,536.282 55.517,513.167 36.06,498.883 60.109,498.883  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "198.443,21.684 205.873,44.798 229.924,44.798 210.468,59.083 217.899,82.198  198.443,67.913 178.986,82.198 186.419,59.083 166.963,44.798 191.012,44.798  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "198.443,135.205 205.873,158.319 229.924,158.319 210.468,172.604 217.899,195.719  198.443,181.434 178.986,195.719 186.419,172.604 166.963,158.319 191.012,158.319  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "198.443,248.726 205.873,271.84 229.924,271.84 210.468,286.125 217.899,309.24  198.443,294.955 178.986,309.24 186.419,286.125 166.963,271.84 191.012,271.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "198.443,362.247 205.873,385.361 229.924,385.361 210.468,399.646 217.899,422.761  198.443,408.476 178.986,422.761 186.419,399.646 166.963,385.361 191.012,385.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "198.443,475.768 205.873,498.883 229.924,498.883 210.468,513.167 217.899,536.282  198.443,521.997 178.986,536.282 186.419,513.167 166.963,498.883 191.012,498.883  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "332.883,21.684 340.315,44.798 364.362,44.798 344.908,59.083 352.339,82.198  332.883,67.913 313.428,82.198 320.859,59.083 301.403,44.798 325.452,44.798  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "332.883,135.205 340.315,158.319 364.362,158.319 344.908,172.604 352.339,195.719  332.883,181.434 313.428,195.719 320.859,172.604 301.403,158.319 325.452,158.319  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "332.883,248.726 340.315,271.84 364.362,271.84 344.908,286.125 352.339,309.24  332.883,294.955 313.428,309.24 320.859,286.125 301.403,271.84 325.452,271.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "332.883,362.247 340.315,385.361 364.362,385.361 344.908,399.646 352.339,422.761  332.883,408.476 313.428,422.761 320.859,399.646 301.403,385.361 325.452,385.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "332.883,475.768 340.315,498.883 364.362,498.883 344.908,513.167 352.339,536.282  332.883,521.997 313.428,536.282 320.859,513.167 301.403,498.883 325.452,498.883  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "464.67,21.684 472.101,44.798 496.15,44.798 476.694,59.083 484.124,82.198 464.67,67.913  445.214,82.198 452.645,59.083 433.189,44.798 457.238,44.798  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "464.67,135.205 472.101,158.319 496.15,158.319 476.694,172.604 484.124,195.719  464.67,181.434 445.214,195.719 452.645,172.604 433.189,158.319 457.238,158.319  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "464.67,248.726 472.101,271.84 496.15,271.84 476.694,286.125 484.124,309.24  464.67,294.955 445.214,309.24 452.645,286.125 433.189,271.84 457.238,271.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "464.67,362.247 472.101,385.361 496.15,385.361 476.694,399.646 484.124,422.761  464.67,408.476 445.214,422.761 452.645,399.646 433.189,385.361 457.238,385.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "464.67,475.768 472.101,498.883 496.15,498.883 476.694,513.167 484.124,536.282  464.67,521.997 445.214,536.282 452.645,513.167 433.189,498.883 457.238,498.883  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "596.456,21.684 603.887,44.798 627.936,44.798 608.48,59.083 615.913,82.198  596.456,67.913 577,82.198 584.431,59.083 564.975,44.798 589.024,44.798  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "596.456,135.205 603.887,158.319 627.936,158.319 608.48,172.604 615.913,195.719  596.456,181.434 577,195.719 584.431,172.604 564.975,158.319 589.024,158.319  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "596.456,248.726 603.887,271.84 627.936,271.84 608.48,286.125 615.913,309.24  596.456,294.955 577,309.24 584.431,286.125 564.975,271.84 589.024,271.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "596.456,362.247 603.887,385.361 627.936,385.361 608.48,399.646 615.913,422.761  596.456,408.476 577,422.761 584.431,399.646 564.975,385.361 589.024,385.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "596.456,475.768 603.887,498.883 627.936,498.883 608.48,513.167 615.913,536.282  596.456,521.997 577,536.282 584.431,513.167 564.975,498.883 589.024,498.883  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "730.894,21.684 738.327,44.798 762.376,44.798 742.919,59.083 750.35,82.198  730.894,67.913 711.44,82.198 718.871,59.083 699.415,44.798 723.464,44.798  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "730.894,135.205 738.327,158.319 762.376,158.319 742.919,172.604 750.35,195.719  730.894,181.434 711.44,195.719 718.871,172.604 699.415,158.319 723.464,158.319  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "730.894,248.726 738.327,271.84 762.376,271.84 742.919,286.125 750.35,309.24  730.894,294.955 711.44,309.24 718.871,286.125 699.415,271.84 723.464,271.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "730.894,362.247 738.327,385.361 762.376,385.361 742.919,399.646 750.35,422.761  730.894,408.476 711.44,422.761 718.871,399.646 699.415,385.361 723.464,385.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "730.894,475.768 738.327,498.883 762.376,498.883 742.919,513.167 750.35,536.282  730.894,521.997 711.44,536.282 718.871,513.167 699.415,498.883 723.464,498.883  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaFlag);
export default __webpack_public_path__ + "static/media/usa_flag.bd8fc127413fccf9cb0167fdacee8ac6.svg";
export { ForwardRef as ReactComponent };